import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "password",
    "passwordConfirmation",
    "lengthRequirement",
    "matchRequirement"
  ]

  static values = {
    minLength: { type: Number, default: 6 },
    maxLength: { type: Number, default: 128 }
  }

  connect() {
    this.validate()
  }

  validate() {
    this.validateLength()
    this.validateMatch()
  }

  validateLength() {
    if (!this.hasPasswordTarget || !this.hasLengthRequirementTarget) return

    const password = this.passwordTarget.value
    const isValid = password.length >= this.minLengthValue && password.length <= this.maxLengthValue

    this.updateRequirement(this.lengthRequirementTarget, isValid, password.length > 0)
  }

  validateMatch() {
    if (!this.hasPasswordTarget || !this.hasPasswordConfirmationTarget || !this.hasMatchRequirementTarget) return

    const password = this.passwordTarget.value
    const confirmation = this.passwordConfirmationTarget.value
    const isValid = password.length > 0 && confirmation.length > 0 && password === confirmation

    this.updateRequirement(this.matchRequirementTarget, isValid, confirmation.length > 0)
  }

  updateRequirement(element, isValid, hasInput) {
    const icon = element.querySelector('[data-icon]')
    const text = element.querySelector('[data-text]')

    if (!hasInput) {
      // Not started - gray/neutral
      element.classList.remove('text-green-600', 'dark:text-green-400', 'text-red-600', 'dark:text-red-400')
      element.classList.add('text-gray-500', 'dark:text-gray-400')
      if (icon) {
        icon.innerHTML = this.circleIcon()
      }
    } else if (isValid) {
      // Valid - green checkmark
      element.classList.remove('text-gray-500', 'dark:text-gray-400', 'text-red-600', 'dark:text-red-400')
      element.classList.add('text-green-600', 'dark:text-green-400')
      if (icon) {
        icon.innerHTML = this.checkIcon()
      }
    } else {
      // Invalid - red x
      element.classList.remove('text-gray-500', 'dark:text-gray-400', 'text-green-600', 'dark:text-green-400')
      element.classList.add('text-red-600', 'dark:text-red-400')
      if (icon) {
        icon.innerHTML = this.xIcon()
      }
    }
  }

  circleIcon() {
    return `<svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/>
    </svg>`
  }

  checkIcon() {
    return `<svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
    </svg>`
  }

  xIcon() {
    return `<svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
    </svg>`
  }
}
